export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_CIDS = "SET_CIDS";
